/* eslint-disable max-len */
import { TableBody, TableHead, TableRow, Icon } from "@mui/material";
import {
  useMemo,
  useState,
  useContext,
  useRef,
  createRef,
  useEffect,
} from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { UserContext } from "../../context/UserContext";
import theme from "../../styles/theme";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import TableComponent, {
  StyledBodyCell,
  StyledHeaderCell,
  StyledTableRow,
} from "../../components/Table";
import {
  EmptyPillarNavigation,
  EmptyPillarTypeDetail,
  PillarNavigationType,
  PillarTypeDetail,
} from "../../types/Roadmap";
import PillarSubdomainModify from "../../components/PillarSubdomainModify";
import Button from "../../components/Button";
import axios from "axios";
import { CustomFlex } from "./ModifyPillarDetail";
import PillarNavigator from "../../components/PillarNavigator";
import PillarSubdomainCreate from "../../components/PillarSubdomainCreate";
import KnowledgeAreaCreate from "../../components/KnowledgeAreaCreate";
import SnackBar from "../../components/SnackBar";
import LoadingSpinner from "../../components/LoadingSpinner";
import ConfirmModal from "../../components/ConfirmModal";
import { VersionContext } from "../../context/VersionContext";
import { SaveButton } from "../../components/PillarOverviewModify";
interface Column {
  id: "title" | "description" | "action";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
function SubdomainKnowledgeAreas() {
  const ref = useRef(null);
  const { pillarId, subdomainId } = useParams();
  const navigate = useNavigate();
  const [isCreateOpen, setIsCreateOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const { version } = useContext(VersionContext);
  const [currentPillar, setCurrentPillar] = useState<PillarTypeDetail>();
  const [knowledgeAreas, setKnowledgeAreas] = useState<Array<any>>([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
  const [subdomainDetail, setSubdomainDetail] = useState<{
    id: string;
    description: string;
    title: string;
    knowledge_areas: Array<{
      id: string;
      description: string;
      title: string;
    }>;
  }>({
    id: "",
    description: "",
    title: "",
    knowledge_areas: [],
  });
  const [pillarNavigation, setPillarNavigation] =
    useState<PillarNavigationType>(EmptyPillarNavigation);
  const [columns, setColumns] = useState<Array<Column>>([
    { id: "title", label: "Knowledge Area Title", minWidth: 200 },
    {
      id: "description",
      label: "Description",
      minWidth: 150,
    },
    {
      id: "action",
      label: "",
      minWidth: 155,
    },
  ]);
  useEffect(() => {
    if (pillarId && subdomainId) {
      // fetchSubdomain(pillarId, subdomainId)
      fetchKnowledgeArea(pillarId, subdomainId);
    }
  }, []);
  const fetchKnowledgeArea = (pillar_id: string, subdomain_id: string) => {
    setLoading(true);
    axios
      .get(`/knowledgearea?subdomain_id=${subdomain_id}`)
      .then((res) => {
        axios
          .get(`/pillar?curriculum_version=${version.version_number}`)
          .then((res1) => {
            axios
              .get(`/subdomain/summary?pillar_id=${pillarId}&curriculum_version=${version.version_number}`)
              .then((res2) => {
                setKnowledgeAreas(res.data.knowledgeareas);
                setPillarNavigation({
                  ...pillarNavigation,
                  id: pillarId || "",
                  title: res1.data.pillars.find((v: any) => v.id === pillarId)
                    .title,
                  subdomains: {
                    ...pillarNavigation.subdomains,
                    id: subdomain_id,
                    title: res2.data.subdomains.find(
                      (v: any) => v.id === subdomainId
                    ).title,
                    knowledge_areas: {
                      ...pillarNavigation.subdomains.knowledge_areas,
                      id: "",
                      title: "",
                    },
                  },
                });
                setLoading(false);
              })
              .catch(() => {
                setLoading(false);
              });
          })
          .catch(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const createKnowledge = (data: any) => {
    setLoading(true);
    axios
      .post("/knowledgearea/new", { ...data, subdomain_id: subdomainId })
      .then((res) => {
        setMessage("Created knowledge area successfully");
        setIsSnackbarOpen(true);
        setLoading(false);
        setIsCreateOpen(false);
        fetchKnowledgeArea(pillarId || "", subdomainId || "");
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to create knowledge area!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };
  const deleteSubdomain = () => {
    axios
      .delete(
        `/knowledgearea/delete?area_id=${currentPillar?.id}&curriculum_version=${version.version_number}`
      )
      .then((res) => {
        setMessage("Knowledge area deleted successfully!");
        setIsSnackbarOpen(true);
        setLoading(false);
        fetchKnowledgeArea(pillarId || "", subdomainId || "");
        setIsConfirmOpen(false);
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to delete knowledge area!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
      });
  };
  return (
    <>
      {isCreateOpen && (
        <KnowledgeAreaCreate
          header="Create Knowledge Area"
          mode="create"
          isOpen={isCreateOpen}
          setOpen={setIsCreateOpen}
          onSaveComplete={(data) => {
            createKnowledge(data);
          }}
        />
      )}
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      <ConfirmModal
        isOpen={isConfirmOpen}
        setOpen={setIsConfirmOpen}
        confirmFunction={() => {
          deleteSubdomain();
        }}
        title={"Delete Knowledge Area"}
        description={"Are you sure you want to delete this knowledge area?"}
      />
      {loading && <LoadingSpinner />}
      <CustomFlex
        style={{
          minHeight: "inherit",
          height: "100%",
          borderBottom: "none",
          alignItems: "flex-start",
          overflowY: "scroll",
          padding: 0,
        }}
      >
        <FlexGrow
          className="visible-scrollbar"
          style={{
            overflowX: "auto",
            maxHeight: "calc(100vh - 70px)",
            minHeight: "calc(100vh - 70px)",
          }}
        >
          <CustomFlex>
            <FlexGrow>
              <PillarNavigator path={pillarNavigation} />
            </FlexGrow>
          </CustomFlex>
          <TableComponent navHeight="170px" aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  if (column.id === "action") {
                    return (
                      <StyledHeaderCell
                        key={column.id}
                        align={column.align}
                        backgroundColor={theme.color.lightBlueGray50}
                        color={theme.color.lightBlueGray800}
                        style={{
                          minWidth: column.minWidth,
                          maxWidth: "165px",
                          textAlign: "end",
                        }}
                      >
                        <SaveButton
                          className="reduce_opct_onhover"
                          onClick={() => setIsCreateOpen(true)}
                          style={{
                            width: "auto",
                            color: "white",
                          }}
                        >
                          <Icon fontSize="small" style={{ paddingRight: 5 }}>
                            add_circle_outline_icon
                          </Icon>
                          Create Knowledge Area
                        </SaveButton>
                      </StyledHeaderCell>
                    );
                  }
                  return (
                    <StyledHeaderCell
                      key={column.id}
                      align={column.align}
                      backgroundColor={theme.color.lightBlueGray50}
                      color={theme.color.lightBlueGray800}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </StyledHeaderCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {knowledgeAreas?.map((row: any, index) => {
                return (
                  <StyledTableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    onDoubleClick={() =>
                      navigate(
                        `/modify/pillar/${pillarNavigation.id}/subdomain/${pillarNavigation.subdomains.id}/knowledge-area/${row.id}`
                      )
                    }
                    // onClick={() => {
                    //   onSelect(row);
                    // }}
                    key={index}
                  >
                    {columns.map((column) => {
                      if (column.id === "action") {
                        return (
                          <StyledBodyCell
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                            style={{
                              verticalAlign: "middle",
                              textAlign: "end",
                              paddingRight: "30px",
                            }}
                            key={column.id}
                            align={column.align}
                          >
                            <FlexBox>
                              <FlexGrow
                                className="reduce_opct_onhover"
                                style={{ marginRight: "16px" }}
                              >
                                <ClickableIcon
                                  onClick={() =>
                                    navigate(
                                      `/modify/pillar/${pillarNavigation.id}/subdomain/${pillarNavigation.subdomains.id}/knowledge-area/${row.id}`
                                    )
                                  }
                                  style={{ textShadow: "0 2px 4px #8080807a" }}
                                  fixedWidth={false}
                                  size={3}
                                  name={"edit"}
                                />
                              </FlexGrow>
                              <FlexGrow
                                className="reduce_opct_onhover"
                                style={{ flexGrow: 0 }}
                              >
                                <ClickableIcon
                                  onClick={() => {
                                    setCurrentPillar(row);
                                    setIsConfirmOpen(true);
                                  }}
                                  style={{
                                    color: "red",
                                    textShadow: "0 2px 4px #8080807a",
                                  }}
                                  fixedWidth={false}
                                  size={3}
                                  name={"delete"}
                                />
                              </FlexGrow>
                            </FlexBox>
                          </StyledBodyCell>
                        );
                      }
                      const value = row[column.id];
                      return (
                        <StyledBodyCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </StyledBodyCell>
                      );
                    })}
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </TableComponent>
        </FlexGrow>
      </CustomFlex>
    </>
  );
}
export default SubdomainKnowledgeAreas;
